import React from "react"
import PropTypes from "prop-types"
import { toggle, setAll } from "../../../redux/selection"
import { showSelectedOnly } from "../../../redux/settings"
import { setParam, fetch } from "../../../redux/query"
import store from "../../../redux"
import { connect } from "react-redux"
import "../Dashboard.less"
import { withRouter } from "../../../lib/withRouter"
import { formatMoney, getDiagnosisCodes, getQuickSightUrl, getViewPatientData, normalizeCharges, postResource } from "../../../lib"
import moment from "moment"

export class ClaimTab extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func
    };

    constructor(props) {
        super(props);
        const startOfMonth = moment().startOf("month");
        const endOfMonth = moment().endOf("month");

        this.state = {
            selectedClaim: null,
            claimListResult: null,
            approveListResult: null,
            unapproveListResult: null,
            selectedFiles: [],
            actionLoading: null,
            loading: false,
            error: null,
            continuationTokens: [null],
            currentPageIndex: 0,
        };
    }


    componentDidMount() {
        console.log(this.props, "claimTab")
        const query = new URLSearchParams(this.props.location.search);

        // CHECK REDIRECT TABS
        const _tab = query.get("_tab");
        if (["demographics", "conditions", "tags"].includes(_tab)) {
            query.delete("_resource");
            const clean = query.toString() ? `?${query.toString()}` : "";
            this.props.router.navigate(`/patient-list${clean}`);
            return;
        }

        // SET ACTIVE TAB
        this.fetchClaimData()
    }

    handlePageChange = (page) => {
        this.setState({ currentPage: page });
    };

    fetchClaimData = async () => {
        try {
            this.setState({ loading: true, error: null });
            const token = this.state.continuationTokens[this.state.currentPageIndex];

            let apiUrl = `${this.props.settings.server.baseUrl}/claims/convert?continuationToken=`;

            if (token) {
                apiUrl += `${btoa(token)}`;
            }

            const data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server
            });

            // New continuation token from server
            const records = data.records || [];
            const newToken = data.nextToken || null;

            this.setState(prev => {
                const updatedTokens = [...prev.continuationTokens];

                // Only push new token if it exists and not already in stack
                if (records.length > 0 && newToken && !updatedTokens.includes(newToken)) {
                    updatedTokens.push(newToken);
                }

                return {
                    claimListResult: records,
                    continuationTokens: updatedTokens,
                    loading: false
                };
            });
        } catch (error) {
            console.error("Search failed:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    handleNextPage = () => {
        const { currentPageIndex, continuationTokens } = this.state;

        const nextToken = continuationTokens[currentPageIndex + 1];
        if (!nextToken) return;

        this.setState(
            { currentPageIndex: currentPageIndex + 1 },
            this.fetchClaimData
        );
    };

    handlePrevPage = () => {
        if (this.state.currentPageIndex === 0) return;

        this.setState(
            { currentPageIndex: this.state.currentPageIndex - 1 },
            this.fetchClaimData
        );
    };

    handleCheckboxChange = (fileName) => {
        this.setState(prev => {
            let updated = [...prev.selectedFiles];

            if (updated.includes(fileName)) {
                updated = updated.filter(f => f !== fileName);
            } else {
                updated.push(fileName);
            }

            return { selectedFiles: updated };
        });
    };

    sendSelectedFiles = async () => {
        const { selectedFiles } = this.state;

        if (selectedFiles.length === 0) {
            alert("Please select at least one file.");
            return;
        }

        this.setState({ actionLoading: "approve" });

        try {
            const apiUrl = `${this.props.settings.server.baseUrl}/claims/move`;

            const response = await postResource({
                url: apiUrl,
                data: selectedFiles,
                dataType: "text"
            });

            // ✅ SUCCESS: clear selected files
            this.setState({ selectedFiles: [] });

            // ✅ REFRESH DATA
            this.fetchClaimData();
        } catch (err) {
            console.error("API Error:", err);
        } finally {
            this.setState({ actionLoading: null });  // <-- stop loading
        }
    };

    handleUnapproveFiles = async () => {
        const { selectedFiles } = this.state;

        if (selectedFiles.length === 0) {
            alert("Please select at least one file.");
            return;
        }

        this.setState({ actionLoading: "unapprove" });

        try {
            const apiUrl = `${this.props.settings.server.baseUrl}/claims/unapproved`;

            const response = await postResource({
                url: apiUrl,
                data: selectedFiles,
                dataType: "text"
            });

            // ✅ SUCCESS: clear selected files
            this.setState({ selectedFiles: [] });

            // ✅ REFRESH DATA
            this.fetchClaimData();
        } catch (err) {
            console.error("API Error:", err);
        } finally {
            this.setState({ actionLoading: null });  // <-- stop loading
        }
    };

    toggleSelectAll = () => {
        const { claimListResult, selectedFiles } = this.state;

        // All file names
        const allFiles = claimListResult.map(c => c.fileName);

        // If all selected → unselect all
        if (selectedFiles.length === allFiles.length) {
            this.setState({ selectedFiles: [] });
        }
        // Otherwise → select all
        else {
            this.setState({ selectedFiles: allFiles });
        }
    };

    render() {
        return (
            this.renderClaimContent()
        )
    }

    renderClaimRows() {
        const { claimListResult, selectedFiles } = this.state;

        if (!claimListResult || claimListResult.length === 0) {
            return (
                <tr>
                    <td colSpan="12" className="text-center">No records found</td>
                </tr>
            );
        }

        return claimListResult.map((claim, index) => {
            const data = claim.jsonData;
            const patient = data?.Patient || {};
            const charges = normalizeCharges(data.Charge);
            const payer = patient?.Policy?.Payer;

            return charges.map((charge, idx) => {
                const units = Number(charge?.Units) || 0;
                const unitPrice = Number(charge?.UnitPrice) || 0;
                const totalPrice = Number(charge?.TotalPrice);

                const totalAmount = totalPrice > 0
                    ? totalPrice
                    : unitPrice * units;

                const effectiveUnitPrice = unitPrice || (totalPrice && units ? totalPrice / units : 0);

                return (
                    <tr key={`${patient.Identifier}-${index}`}>
                        <td className="text-center">
                            <input
                                type="checkbox"
                                checked={selectedFiles.includes(claim.fileName)}
                                onChange={() => this.handleCheckboxChange(claim.fileName)}
                            />
                        </td>

                        <td className="text-center">{patient.Identifier || "-"}</td>

                        <td>{`${patient.FirstName || ""} ${patient.LastName || ""}`.trim()}</td>

                        <td className="text-center">{patient.Gender || "-"}</td>
                        <td className="text-center">{payer?.Name || "-"}</td>

                        <td className="text-center">{charge?.FromDate || "-"}</td>
                        <td className="text-center">{charge?.ToDate || "-"}</td>

                        <td className="text-center">{charge?.CPTCode || "-"}</td>

                        <td className="text-center">{getDiagnosisCodes(charge)}</td>

                        <td className="text-center">{units || "-"}</td>

                        <td className="text-right">{formatMoney(effectiveUnitPrice) || "-"}</td>

                        <td className="text-right">{formatMoney(totalAmount) || "-"}</td>
                    </tr>
                );
            });
        });
    }


    renderClaimContent() {
        const { loading, error, claimListResult } = this.state;
        const hasPrev = this.state.currentPageIndex > 0;
        const hasNext = !!this.state.continuationTokens[this.state.currentPageIndex + 1];
        const currentPage = this.state.currentPageIndex + 1;

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        const searchHeader = (
            <div className="panel-default">
                <div className="panel-heading" style={{ padding: "5px 15px" }}>
                    <div className="row d-flex align-items-center">
                        <div className="col-xs-4">
                            <b className="text-primary">
                                <i className="fa fa-address-card-o" /> Claim Review
                            </b>
                        </div>
                        <div className="col-xs-8">
                            <div className="row">
                                <div className="col-md-6 pull-right text-right">
                                    <button
                                        className="btn btn-sm btn-primary"
                                        style={{ marginRight: "0.75rem" }}
                                        onClick={this.sendSelectedFiles}
                                        disabled
                                    // disabled={
                                    //     this.state.selectedFiles.length === 0 ||
                                    //     this.state.actionLoading !== null
                                    // }
                                    >
                                        {this.state.actionLoading === "approve" ?
                                            (<span>Approve <i className="fa fa-spinner spin" /></span>) :
                                            ("Approve")
                                        }
                                    </button>

                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={this.handleUnapproveFiles}
                                        disabled
                                    // disabled={
                                    //     this.state.selectedFiles.length === 0 ||
                                    //     this.state.actionLoading !== null
                                    // }
                                    >
                                        {this.state.actionLoading === "unapprove" ?
                                            (<span>Unapprove <i className="fa fa-spinner spin" /></span>) :
                                            ("Unapprove")
                                        }
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        if (!claimListResult || claimListResult.length === 0) {
            return (
                <>
                    {searchHeader}
                    <p style={{ margin: "0.5rem 1rem" }}>No claim data available.</p>
                </>
            );
        }

        return (
            <>
                <div className="tab-content-wrapper" style={{ marginBottom: "2.5rem" }}>
                    {searchHeader}
                    <div className="panel-default">

                        <div className="table-responsive">
                            <table className="table table-condensed table-hover table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th className="text-center">
                                            <input
                                                type="checkbox"
                                                checked={
                                                    this.state.selectedFiles.length === this.state.claimListResult.length
                                                }
                                                onChange={this.toggleSelectAll}
                                            />
                                        </th>
                                        <th className="text-center">Patient ID</th>
                                        <th>Patient Name</th>
                                        <th className="text-center">Gender</th>
                                        <th className="text-center">Payer</th>
                                        <th className="text-center">From Date</th>
                                        <th className="text-center">To Date</th>
                                        <th className="text-center">CPT Code</th>
                                        <th className="text-center">ICD Code</th>
                                        <th className="text-center">Units</th>
                                        <th className="text-center">Unit Price ($)</th>
                                        <th className="text-center">Total Amount ($)</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {this.renderClaimRows()}
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
                <div className="app-footer"
                    style={{
                        position: "fixed",
                        bottom: 0,
                        width: "100%",
                        backgroundColor: "#f5f5f5",
                        borderTop: "1px solid #ddd",
                    }}
                >
                    <div className="container-fluid" style={{ width: "100%" }}>
                        <div className="row">

                            {/* Prev Button */}
                            <div className="col-xs-3 col-sm-4 text-right">
                                <a
                                    href="#prev"
                                    onClick={e => {
                                        e.preventDefault();
                                        if (hasPrev) this.handlePrevPage();
                                    }}
                                    style={{
                                        color: hasPrev ? '#007bff' : '#6c757d',
                                        cursor: hasPrev ? 'pointer' : 'not-allowed',
                                        textDecoration: 'none'
                                    }}
                                >
                                    <i className="fa fa-arrow-left" /> Prev
                                </a>
                            </div>

                            {/* Current Page Number */}
                            <div className="col-xs-6 col-sm-4 text-center">
                                <span className="pagination-status">
                                    Page {currentPage}
                                </span>
                            </div>

                            {/* Next Button */}
                            <div className="col-xs-3 col-sm-4 text-left">
                                <a
                                    href="#next"
                                    onClick={e => {
                                        e.preventDefault();
                                        if (hasNext) this.handleNextPage();
                                    }}
                                    style={{
                                        color: hasNext ? '#007bff' : '#6c757d',
                                        cursor: hasNext ? 'pointer' : 'not-allowed',
                                        textDecoration: 'none'
                                    }}
                                >
                                    Next <i className="fa fa-arrow-right" />
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </>
        );
    }

}

export default connect(state => state)(withRouter(ClaimTab));
